document.addEventListener('alpine:init', () => {

    Alpine.data('admin_team_management_index_x_data', () => ({
        view_team_modal: { // scope for the view team modal
            view_team_details_modal: false,
            show_title: '',
            team_members: []
        },
        swap_owner_modal: swap_owner_model_state(),
        view_team_modal_event(event) {
            event.preventDefault()
            // Value assignment for the view team modal
            this.view_team_modal.show_title = event.currentTarget.dataset.showTitle
            this.view_team_modal.team_members = JSON.parse(event.currentTarget.dataset.teamMemberDetails)

            // check if team members are present. Only then show the modal when team_members are present
            if (this.view_team_modal.team_members.length > 0) {
                this.view_team_modal.view_team_details_modal = true
            } else {
                alert('No team members found')
            }
        },
        swap_owner_modal_event(event) {
            event.preventDefault()

            // Clear state
            this.reset_swap_owner_modal()

            // Value assignment for the swap owner modal
            let arr = JSON.parse(event.currentTarget.dataset.teamMembers)
            arr.forEach((element) => {
                this.swap_owner_modal.team_members.push({
                    id: element[0],
                    first_name: element[1],
                    last_name: element[2],
                    email: element[3],
                    owner: element[4]
                })
            })

            console.log(this.swap_owner_modal.team_members)

            // check if team members are present. Only then show the modal when team_members are present
            if (this.swap_owner_modal.team_members.length > 0) {
                this.swap_owner_modal.swap_owner_modal = true
            } else {
                alert('No team members found')
                return false;
            }

            // Check where the owner is true and assign the current owner
            this.swap_owner_modal.team_members.forEach((member) => {
                if (member.owner === true) {
                    this.swap_owner_modal.current_owner.id = member.id
                    this.swap_owner_modal.current_owner.first_name = member.first_name
                    this.swap_owner_modal.current_owner.last_name = member.last_name
                    this.swap_owner_modal.current_owner.email = member.email
                } else {
                    this.swap_owner_modal.non_owner_members.push(member)
                }
            })

            // Open modal
            this.swap_owner_modal.show_modal = true
        },
        selected_candidate(candidate) {
            this.swap_owner_modal.new_owner.id = candidate.id
            this.swap_owner_modal.new_owner.first_name = candidate.first_name
            this.swap_owner_modal.new_owner.last_name = candidate.last_name
            this.swap_owner_modal.new_owner.email = candidate.email
            this.swap_owner_modal.show_dropdown = false
        },
        reset_swap_owner_modal() {
            this.swap_owner_modal = swap_owner_model_state()
        },
        perform_swap_owner() {
            if (this.swap_owner_modal.current_owner.id === this.swap_owner_modal.new_owner.id) {
                alert('Owner is already the same')
                return false
            }

            if (this.swap_owner_modal.new_owner.id === '') {
                alert('Please select a new owner or click cancel')
                return false
            }

            let data = {
                new_owner_id: this.swap_owner_modal.new_owner.id
            }

            let url = this.$refs.main_x_ref.dataset.swapUrl
            let that = this

            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: JSON.stringify(data)
            }).then(response => {
                if (response.ok) {
                    return response.json()
                }
                throw new Error('Network response was not ok.')
            }).then(data => {
                this.reset_swap_owner_modal()
                window.location.reload()

            }).catch(error => {
                console.error('There has been a problem with your fetch operation:', error)

            })
        }
    }))
});

function swap_owner_model_state() {
    return {
        show_modal: false,
        show_dropdown: false,
        current_owner: {
            id: '',
            first_name: '',
            last_name: '',
            email: ''
        },
        new_owner: {
            id: '',
            first_name: '',
            last_name: '',
            email: ''
        },
        non_owner_members: [],
        team_name: '',
        team_members: []
    };
}